import {
  ImpactOccurredType,
  NotificationOccurredType
} from "hooks/useAppInit/utils/initTelegramData"

interface IHapticFeedback {
  type?: "impactOccurred" | "notificationOccurred"
  style?: ImpactOccurredType | NotificationOccurredType
}

// @ts-ignore
// export const hapticFeedback = ({}: IHapticFeedback = {}) => {}

export const hapticFeedback = ({
  type = "impactOccurred",
  style = "light"
}: IHapticFeedback = {}) => {
  try {
    const haptic = window?.Telegram?.WebApp?.HapticFeedback

    if (haptic) {
      if (type === "impactOccurred") {
        haptic.impactOccurred(style as ImpactOccurredType)
      } else if (type === "notificationOccurred") {
        haptic.notificationOccurred(style as NotificationOccurredType)
      }
    }
  } catch (error) {
    console.error("hapticFeedback error:", error)
  }
}
